// Don't import this file with '* as Device'. It's known to make VSCode IntelliSense crash.
import {getOSAndName} from 'expensify-common/dist/Device';

export default getOSAndName;
